import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=ab7a8d32&scoped=true&"
import script from "./TermsConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsConditions.vue?vue&type=script&lang=ts&"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=ab7a8d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7a8d32",
  null
  
)

export default component.exports